import { render } from "./ShowProducts.vue?vue&type=template&id=d3d3d2fa&scoped=true"
import script from "./ShowProducts.vue?vue&type=script&lang=js"
export * from "./ShowProducts.vue?vue&type=script&lang=js"

import "./ShowProducts.vue?vue&type=style&index=0&id=d3d3d2fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d3d2fa"]])

export default __exports__